import { render, staticRenderFns } from "./bill-item-details.vue?vue&type=template&id=204c592a&scoped=true&"
import script from "./bill-item-details.vue?vue&type=script&lang=js&"
export * from "./bill-item-details.vue?vue&type=script&lang=js&"
import style0 from "./bill-item-details.vue?vue&type=style&index=0&id=204c592a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204c592a",
  null
  
)

export default component.exports